import { constantRouterMap } from '@/router'
import Layout from '@/layout/Layout'
/**
 * 遍历数组，生成路由树
 * @param roles 后台权限列表
 */
function createAsyncRouter(roles){
	let asyncRouterList = new Array;
	let operaPermList = new Array
	/*排序数组*/
	let roleList = roles;
	/*遍历第一层数组，生成左侧栏*/
	roleList.forEach(function(role){
		let subRole = role.childrenPermissionList;
		let subRoleChildren = new Array;
		/*遍历第二层数组，生成子页面*/
		subRole.forEach(function(subPage){
			let subPageChildren = new Array
			let subPageChildrenList = new Array
			if (subPage.childrenPermissionList && subPage.childrenPermissionList.length > 0){
				subPageChildren = subPage.childrenPermissionList;
				subPageChildren.forEach(function(child){
					subPageChildrenList.push({
						title:child.pmsName,
						// name:child.pmsName,
						code:child.pmsCode,
						meta:{
							code:child.pmsCode,
							name:child.pmsRouteName,
							path:child.pmsId
						},
						path:"/"+child.pmsId
					})
					operaPermList.push(child.pmsCode)
				})
			}
			subRoleChildren.push({
				code:subPage.pmsCode,
				title:subPage.pmsName,
				name:subPage.pmsName,
				meta:{
					code:subPage.pmsCode,
					name:subPage.pmsRouteName,
					path:subPage.pmsResource
				},
				path:subPage.pmsResource,
				component: () => import('@/pages'+subPage.pmsResource),
				children:subPageChildrenList
			})
		})
		asyncRouterList.push({
			path:role.pmsResource,
			component: Layout,
			redirect:subRole[0].pmsResource,
			icon:role.pmsIcon,
			meta:{
				code:role.pmsCode,
				name:role.pmsRouteName,
				path:role.pmsResource
			},
			title:role.pmsName,
			name:role.pmsName,
			code:role.pmsCode,
			children:subRoleChildren,
			isShow:true,
		})
	})
	return [asyncRouterList,operaPermList];
}


const permission = {
	state: {
		routers: constantRouterMap,
		operaPermList:new Array,
		addRouters: []
	},
	mutations: {
		SET_ROUTERS: (state, routers) => {
			state.addRouters = routers
			state.routers = constantRouterMap.concat(routers)
			// state.routers = routers
		},
		SET_OPERAPERM_LIST:(state,list) =>{
			state.operaPermList = list
		}
	},
	actions: {
		generateRoutes({ commit }, data) {
		return new Promise(resolve => {
			const { roles } = data
			commit('SET_ROUTERS', createAsyncRouter(roles)[0])
			commit('SET_OPERAPERM_LIST', createAsyncRouter(roles)[1])
			resolve()
		})
		}
	}
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js